export default [
  'M31.294 37.125H9.204c-1.041 0-1.896-.838-1.896-1.859V15.818l-.117.336L17.53 3.125l-.441.211h14.204c1.042 0 1.897.838 1.897 1.86v30.07c0 1.021-.855 1.86-1.897 1.86zM31.786 39C33.555 39 35 37.598 35 35.881V4.12C35 2.402 33.555 1 31.786 1H16.629a.602.602 0 0 0-.47.223L5.125 14.984A.567.567 0 0 0 5 15.34V35.88C5 37.598 6.445 39 8.214 39h23.572z',
  'M17.645 3L17.645 15.453 18.322 14.907 6 14.907 6 16 18.322 16 19 16 19 15.453 19 3z',
  'M11 22L29 22 29 21 11 21z',
  'M29 27L29 26 11 26 11 27z',
  'M29 32L29 31 11 31 11 32z',
];
